import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'millisecHhmmss'
})
export class MillisecHhmmssPipe implements PipeTransform {
  transform(value: number, format?: string): any {
    const ms = value % 1000;
    value = (value - ms) / 1000;
    const secs = value % 60;
    value = (value - secs) / 60;
    const mins = value % 60;
    const hrs = (value - mins) / 60;
    let days = '';
    let time = '';
    if (hrs) {
      time = hrs + ' h : ';
      if (hrs > 24) {
        days = Math.ceil(hrs / 24) + ' days';
      }
    }
    if (days) {
      return days;
    } else if (format === 'hh:mm:ss') {
      return time + mins + ' m: ' + secs + ' s';
    } else {
      return time + mins + ' m: ' + secs + ' s: ' + ms + ' ms';
    }
  }
}
